import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';
import CalendarEntryUpdateModal from '../calendar/calendarEntry-update';
import CalendarEntryCreateModal from '../calendar/calendarEntry-new';
import CalendarEntryDeleteModal from '../calendar/calendarEntry-deleteModal';
import ClasseList from './classeList';
import Calendar from './calendar';
const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute path={`${match.url}/:ecoleid/:anneeScolaireId/:classeid/calendarEntry`} component={Calendar} />
      <ErrorBoundaryRoute path={`${match.url}/:ecoleid/:anneeScolaireId`} component={ClasseList} />
    </Switch>
    <ErrorBoundaryRoute
      path={`${match.url}/:ecoleid/:anneeScolaireId/:classeid/calendarEntry/:id/update`}
      component={CalendarEntryUpdateModal}
    />
    <ErrorBoundaryRoute
      path={`${match.url}/:ecoleid/:anneeScolaireId/:classeid/calendarEntry/:id/duplicate`}
      component={CalendarEntryUpdateModal}
    />
    <ErrorBoundaryRoute path={`${match.url}/:ecoleid/:anneeScolaireId/:id/calendarEntry/new`} component={CalendarEntryCreateModal} />
    <ErrorBoundaryRoute
      path={`${match.url}/:ecoleid/:anneeScolaireId/:classeid/calendarEntry/:id/delete`}
      component={CalendarEntryDeleteModal}
    />
  </>
);

export default Routes;
